import axios from 'axios';
import Cookies from 'js-cookie';
import { BACKEND_API_URL } from '../utils/api';

const getAuthHeaders = () => ({
    Authorization: `Token ${Cookies.get('access_token')}`,
    'Content-Type': 'application/json',
});

/**
 * Fetch users and tags for filter dropdowns
 */
export const fetchUsersAndTags = async () => {
    const response = await axios.get(`${BACKEND_API_URL}/api/users_and_tags`, {
        headers: getAuthHeaders(),
    });
    return response.data;
};

/**
 * Fetch recent tags
 */
export const fetchRecentTags = async () => {
    const response = await axios.get(`${BACKEND_API_URL}/api/recent_tags`, {
        headers: getAuthHeaders(),
    });
    return response.data;
};

/**
 * Execute search with given filters
 * @param {Object} filters - Search filters
 * @param {string} searchType - Optional comma-separated types: 'folders', 'links', 'messages' (default: all)
 */
export const executeSearch = async (filters, searchType = null) => {
    const { query, assignee, author, selectedTags, tagMethodOr, bookmarkedOnly, ancestorId, status, channelIds, mediaType, sentBy, sentTo, mentionsOnly, dateFrom, dateTo } = filters;

    const params = new URLSearchParams();
    params.set('query', query || '');

    if (assignee) params.set('assigned_to', assignee);
    if (author) params.set('created_by', author);
    if (selectedTags?.length > 0) params.set('tags', selectedTags.join(','));
    if (!tagMethodOr) params.set('tag_method', 'and');
    if (bookmarkedOnly) params.set('bookmarked_only', 'true');
    if (ancestorId) params.set('ancestor_id', ancestorId);
    if (status?.length > 0) params.set('status', status.map(s => encodeURIComponent(s)).join(','));
    if (channelIds?.length > 0) params.set('channel_ids', channelIds.join(','));
    if (mediaType) params.set('media_type', mediaType);
    if (sentBy) params.set('sent_by', sentBy);
    if (sentTo) params.set('sent_to', sentTo);
    if (mentionsOnly) params.set('mentions_only', 'true');
    if (dateFrom) params.set('date_from', dateFrom);
    if (dateTo) params.set('date_to', dateTo);
    if (searchType) params.set('search_type', searchType);

    const response = await axios.get(`${BACKEND_API_URL}/api/search?${params.toString()}`, {
        headers: getAuthHeaders(),
    });

    return response.data;
};

/**
 * Normalize folder status from numeric to string
 */
export const normalizeFolder = (folder) => {
    const STATUS_MAP = [
        "Taking Longer", "Doing", "Doing-in-bg", "Paused", "TODO",
        "Block-on-asm", "Blocked-on-purchase", "Blocked-on-discussion", "Blocked", "Done"
    ];

    let status = folder.status;
    if (status && status.length <= 2) {
        status = STATUS_MAP[parseInt(status, 10) - 1];
    }

    return { ...folder, status: status || '' };
};

